import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import { normalizeAiMarkdown } from '../../utils/normalizeAiMarkdown';
import { chatMarkdownComponents } from './chatMarkdownComponents';

const markdownProseClass =
  'prose prose-slate prose-sm max-w-none break-words ' +
  'prose-p:text-body prose-p:leading-relaxed prose-p:my-2 prose-p:first:mt-0 ' +
  'prose-headings:text-ink prose-headings:font-semibold prose-headings:scroll-mt-4 ' +
  'prose-h1:text-base prose-h2:text-base prose-h3:text-sm prose-h4:text-sm ' +
  'prose-headings:mt-4 prose-headings:mb-2 prose-headings:first:mt-0 ' +
  'prose-strong:text-ink prose-strong:font-semibold ' +
  'prose-ul:my-2 prose-ol:text-body prose-li:my-1 prose-li:leading-relaxed ' +
  'prose-li:marker:text-primary/80 ' +
  'prose-ol:my-2 ' +
  'prose-hr:border-hairline prose-hr:my-4 ' +
  'prose-blockquote:border-primary/40 prose-blockquote:text-body prose-blockquote:italic ' +
  'prose-code:text-blue-600 dark:prose-code:text-blue-400 prose-code:bg-blue-50 dark:prose-code:bg-blue-900/30 prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded-md prose-code:font-normal prose-code:before:content-none prose-code:after:content-none ' +
  'prose-pre:bg-surface-strong prose-pre:border prose-pre:border-hairline prose-pre:rounded-lg prose-pre:text-body ' +
  'prose-table:my-0';

interface MarkdownTextProps {
  children: string;
  className?: string;
}

export default function MarkdownText({ children, className = '' }: MarkdownTextProps) {
  const body = normalizeAiMarkdown(children || '');
  if (!body) {
    return (
      <span className="italic text-muted">(ไม่มีผลลัพธ์)</span>
    );
  }
  return (
    <div className={`${markdownProseClass} ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        components={chatMarkdownComponents}
      >
        {body}
      </ReactMarkdown>
    </div>
  );
}